module.exports = __webpack_public_path__ + "img/lions-roar.405a36e6.webp";